import React, { Component } from 'react';
import { View, Scene, Text, Button, AppHeader, TextInput, TextArea, isWeb } from 'core';
import * as actions from 'actions';
import { css, theme } from 'constants';
import { lang } from 'lang';

class EditGroupInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { description: props.selected.description, title: props.selected.title };
  }
  render() {
    const { selected, status } = this.props;
    let { title, description } = this.state;
    return (
      <Scene avoidKeyboard style={{ justifyContent: 'space-between' }}>
        <AppHeader title={'Group Info'} close />
        <View style={styles.container}>
          <View style={styles.column}>
            <Text style={styles.label}>{lang.TITLE}</Text>
            <TextInput onChangeText={title => this.setState({ title })} style={styles.field} value={title} />
          </View>
          <View style={styles.column}>
            <Text style={styles.label}>{lang.DESCRIPTION}</Text>
            <TextArea onChangeText={description => this.setState({ description })} value={description} font_size={theme.font_md} min_row={4} max_row={6} />
          </View>
        </View>
        <Button
          style={styles.btn}
          title={lang.SAVE}
          onPress={() => actions.sendUpdateGroup({ group_id: selected.id, title, description })}
          status={status}
          onSuccess={() => {
            actions.clickCloseModal();
          }}
        />
      </Scene>
    );
  }
}
const styles = css({
  container: {
    paddingHorizontal: isWeb ? 70 : 20,
    paddingVertical: isWeb ? 40 : 20,
    flex: 1
  },
  input: {
    padding: 10,
    alignSelf: 'center',
    margin: 20
  },
  btn: {
    marginBottom: 20,
    alignSelf: 'center'
  },
  field: {
    width: 'auto'
  },
  label: {
    minWidth: 80,
    marginRight: 15,
    marginVertical: 5,
    color: theme.gray_color
  },
  column: {
    marginBottom: 30
  }
});

export default EditGroupInfo;



// WEBPACK FOOTER //
// ./src/components/modals/edit_group.js